import React from 'react';
import Lottie from 'lottie-react';
import LoaderDark from './LoaderDark.json';
import styles from './Loader.scss';
const Loader = ({ absolute = false, width, height, className, loaderColor, style, }) => (React.createElement("div", { className: `loader ${styles.loader} ${className ?? ''}`, style: { position: absolute ? 'absolute' : 'fixed', ...(style ?? {}) }, "aria-hidden": true },
    React.createElement(Lottie, { animationData: LoaderDark, style: { width: width ?? 'auto', height: height ?? 'auto', color: loaderColor ?? undefined } })));
export default Loader;
